<template>
  <div class="flex-center">
    <div class="d-flex" :id="'kr-award-icon-' + kr.id">
      <i class="award-icon pointer" :id="'kr-award-tour-' + instanceId"></i>
    </div>
    <b-popover
      ref="popover"
      :target="'kr-award-icon-' + kr.id"
      delay="500"
      triggers="hover"
      placement="bottom"
      custom-class="text-medium text-center"
    >
      <div class="d-flex flex-column content-container">
        <div class="text-center text-gradient">This KR has hit a milestone</div>
        <b-button @click="showAwardModal = true" variant="primary" class="text-small award-btn"
          >Give an award to celebrate
        </b-button>
        <a
          class="text-secondary text-small"
          href="https://thenorth.io/celebrate-wins-big-and-small/"
          target="_blank"
          >Learn more about award
        </a>
      </div>
    </b-popover>
    <give-award
      :context="awardContext"
      :team-id="kr.teamId"
      v-model="showAwardModal"
      @awarded="$emit('awarded')"
      v-if="showAwardModal"
    />
    <tour :steps="KR_AWARD_ICON_TOUR_CONFIG" :meta="TOUR.KR_AWARD_ICON" v-if="showTour" />
  </div>
</template>

<script>
import Tour from '@/components/tour/Tour'
import { KR_AWARD_ICON_TOUR_CONFIG } from '@/components/tour/tour-config/awardTour'
import { TOUR } from '@/components/tour/tour-config/tours'
import getEntityAwardContext from '@/utils/getEntityAwardContext'
import { BPopover, BButton } from 'bootstrap-vue'
import GiveAward from '@/components/award/GiveAward'

let instanceId = 1
/**
 * This lets user give award on a KR.
 * This exposes an award icon, hover of which opens a popover which has entry point of giving the award
 *
 * @emits
 * - awarded
 *
 */
export default {
  name: 'KrAwardIcon',
  props: {
    kr: Object
  },
  components: {
    BPopover,
    BButton,
    GiveAward,
    Tour
  },
  data() {
    return {
      showAwardModal: false,
      KR_AWARD_ICON_TOUR_CONFIG,
      TOUR,
      instanceId: instanceId++,
      showTour: false
    }
  },
  computed: {
    awardContext() {
      return {
        ...getEntityAwardContext(this.kr, 'kr'),
        goalId: this.kr.goalId
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.showTour = this.instanceId === 1
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.award-btn {
  padding: 2px 20px;
  margin: 10px 0;
}

.content-container {
  max-width: 250px;
}
</style>
